import React, { useState, useContext } from 'react'
import classNames from 'classnames'
import Icon from 'meinian-package/src/component/icon'
import * as userAuth from 'meinian-package/src/utils/auth'
import { UpgradeModal } from 'component/imageAction/edit'
import { picProcess } from 'meinian-package/src/utils/image'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import { STYLE_PLAN_TEXT, STYLE_TYPE_TEXT } from 'common/config/enum'
import { TYPE } from 'component/imageDetail/userDefinedProps'
import LazyLoadImage from 'meinian-package/src/baseComponent/lazyLoadImage'
import link from 'meinian-package/src/utils/link'
import { ImageDetailContext } from '../../../content'
import ModuleItem from './moduleItem'
import MultiItem from './multiItem'
import type { TCurrentImageInfo, IQueryParams } from '../../../interface'
import type { IImageDetailContext } from '../../../content'
import styles from './index.module.less'

interface InfoDetailProps {
  currentImage: TCurrentImageInfo
  queryParams: IQueryParams
  hasZkOfficialStyle: boolean
  setQuickEditVisible: React.Dispatch<React.SetStateAction<boolean>>
  onChange: (success: boolean, newItemData: any) => void
}

export default ({ setQuickEditVisible, currentImage, queryParams, hasZkOfficialStyle, onChange }: InfoDetailProps) => {
  const [propIndex, setPropIndex] = useState(0)
  const [editVisible, setEditVisible] = useState(false)
  const { onInit, onDeleteItem, setBanOperation, boxIndex, tags, samples, upgradeInfo } =
    useContext<IImageDetailContext>(ImageDetailContext)
  const auth = currentImage.loginUserInfo?.inspirationPermissions || []
  const [isFold, setIsFold] = useState(true)

  return (
    <div className={classNames(styles.infoBlock, 'mt32')}>
      <div className={styles.titleLine}>
        <div className={styles.point} />
        <div className={styles.mainTitle}>款式详情</div>
        <div className={styles.mainTitleRight}>
          {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle ? null : (
            <>
              <a
                className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
                style={{ marginLeft: '8px' }}
                onClick={() => {
                  setPropIndex(1)
                  setEditVisible(true)
                  setBanOperation(true)
                }}
              >
                <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />
                编辑
              </a>
              <div
                onClick={() => setQuickEditVisible(true)}
                style={{ marginLeft: '4px' }}
                className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
              >
                <Icon type="m-kuaisubianji" style={{ marginRight: 2, fontSize: '16px' }} />
                快速编辑
              </div>
            </>
          )}
        </div>
        <a className={classNames(styles['fold-dynamic'], 'fill-white-bg')} onClick={() => setIsFold((pre) => !pre)}>
          {isFold ? '展开' : '收起'}
          <Icon type="m-Vxing_xia" style={{ transform: isFold ? undefined : 'rotate(180deg)', transition: 'all 0.3s' }} />
        </a>
      </div>
      <div className={styles.infoBlockContext} style={{ maxHeight: `${isFold ? '0px' : '10000px'}` }}>
        <ModuleItem
          mb12={false}
          style={{ marginBottom: '12px' }}
          label="参考价格"
          value={
            upgradeInfo?.price
              ? `${upgradeInfo.platformId === PLATFORM_VALUE.CROSSBORDER ? '$' : '¥'}${Number.parseFloat(
                  upgradeInfo.price
                )?.toFixed(2)}`
              : upgradeInfo?.price
          }
        />
        <MultiItem
          label="款式标签"
          values={tags.map((item) => ({ value: item.tagName, ...item }))}
          onClickTag={(_, item) => {
            window.open(`/meinian/home/tag/detail?tagId=${item.id}&tagName=${item.value}`)
          }}
        />
        <ModuleItem label="所属行业" value={upgradeInfo?.gender} mb12={false} style={{ marginBottom: '12px' }} />
        <MultiItem label="款式颜色" values={upgradeInfo.color ? JSON.parse(upgradeInfo.color) : []} />
        <div className={styles.secondTitle}>
          <div className={styles.title}>款式特征</div>
          {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle ? null : (
            <a
              className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
              onClick={() => {
                setPropIndex(2)
                setEditVisible(true)
                setBanOperation(true)
              }}
            >
              <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />
              编辑
            </a>
          )}
        </div>
        <ModuleItem label="开款计划" value={STYLE_PLAN_TEXT[upgradeInfo.stylePlan]} />
        <ModuleItem label="款式类型" value={STYLE_TYPE_TEXT[upgradeInfo.styleType]} />
        <div className={styles.secondTitle}>
          <div className={styles.title}>款式属性</div>
          {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle ? null : (
            <a
              className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
              onClick={() => {
                setPropIndex(3)
                setEditVisible(true)
                setBanOperation(true)
              }}
            >
              <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />
              编辑
            </a>
          )}
        </div>
        {upgradeInfo.propertyValueDTOList?.length > 0 || upgradeInfo.relatedInspirationUrl ? (
          <div>
            {upgradeInfo.propertyValueDTOList?.map((prop) => {
              if (
                prop.propertyType === TYPE.MULTIPLE ||
                prop.propertyType === TYPE.TAG ||
                (prop.propertyType === TYPE.MEMBER && prop.memberPropertyStructDTO.isMulti)
              ) {
                return (
                  <MultiItem
                    label={prop.propertyName}
                    values={prop.propertyType === TYPE.MEMBER ? prop.nameList : prop.values.filter((m) => m)}
                  />
                )
              }
              if (prop.propertyType === TYPE.SINGLE) {
                return <ModuleItem label={prop.propertyName} value={prop.values?.join('/')} />
              }
              if (prop.propertyType === TYPE.LINK) {
                return (
                  <ModuleItem
                    label={prop.propertyName}
                    value={
                      prop.values.filter((m) => m)?.[0] ? (
                        <a title={prop.values[0]} href={prop.values[0]} target="_blank" rel="noreferrer">
                          {prop.values[0]}
                        </a>
                      ) : (
                        ''
                      )
                    }
                  />
                )
              }
              if (prop.propertyType === TYPE.BOOL) {
                let val = ''
                if (prop.booleanPropertyStructDTO.trueValue == '是') {
                  val = prop.values?.[0] == '1' ? '是' : '否'
                } else {
                  val = prop.values?.[0] == '1' ? '有' : '无'
                }
                return <ModuleItem label={prop.propertyName} value={val} />
              }
              return (
                <ModuleItem
                  label={prop.propertyName}
                  value={
                    prop.propertyType === TYPE.MEMBER
                      ? !prop.nameList.length
                        ? ''
                        : prop.nameList
                      : prop.values.filter((m) => m)?.[0]
                  }
                />
              )
            })}
            {upgradeInfo.relatedInspirationUrl && (
              <ModuleItem
                label="关联款式"
                value={upgradeInfo.relatedInspirationUrl}
                styleValue={{ color: 'var(--m-link-normal)', cursor: 'pointer' }}
                onClickValue={(val) => {
                  window.open(val)
                }}
              />
            )}
          </div>
        ) : (
          <div className={styles['list-empty']}>未选择行业，请点击「编辑」选择行业后填写款式属性</div>
        )}
        <div className={styles.secondTitle}>
          <div className={styles.title}>相关商品</div>
          {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle ? null : (
            <a
              className={classNames(styles['edit-info-btn'], 'fill-white-bg')}
              onClick={() => {
                setPropIndex(4)
                setEditVisible(true)
                setBanOperation(true)
              }}
            >
              <Icon type="m-bianji" style={{ marginRight: 2, fontSize: '16px' }} />
              编辑
            </a>
          )}
        </div>
        {upgradeInfo.goods?.map((item) => {
          return <Goods data={item} />
        })}

        {samples.length ? (
          <>
            <div className={styles.secondTitle}>
              <div className={styles.title}>关联样衣</div>
            </div>
            <div className={styles.samples}>
              {samples.map((sample) => (
                <a
                  className="sample"
                  href={`/meinian/detail/sample/image?sampleCode=${sample.sampleCode}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <LazyLoadImage src={sample.mainImgUrl} />
                  <div className="sample-title line-1">{sample.name}</div>
                  <div className="sample-code">{sample.sampleCode}</div>
                </a>
              ))}
            </div>
          </>
        ) : null}
      </div>
      {editVisible ? (
        <UpgradeModal
          visible={editVisible}
          setVisible={(val) => {
            setEditVisible(val)
            setBanOperation(val)
          }}
          inspirationId={queryParams.inspirationId}
          onClose={() => {
            setEditVisible(false)
            setBanOperation(false)
          }}
          currentImage={currentImage}
          onChange={(success, itemData) => {
            onChange?.(success, itemData)
            onInit()
            setEditVisible(false)
          }}
          blogId={queryParams.blogId}
          onDeleteItem={onDeleteItem}
          propIndex={propIndex}
          boxIndex={boxIndex}
        />
      ) : null}
    </div>
  )
}

function Goods({ data }) {
  const { title, picUrl, price, minPrice } = data || {}
  if (!data) return null
  return (
    <div
      className={styles.goods}
      onClick={() =>
        userAuth.hasAuth('item_collect_or_cancel') || userAuth.hasAuth('dl_tiktok_data')
          ? link.toGoodDetail(data.itemId)
          : window.open(`/df/detail/image?blogIds=${data.itemId}`)
      }
    >
      <img src={picProcess(picUrl)} className="item-image" />
      <div className="info">
        <div className="item-title text-overflow">{title}</div>
        <div className="price">
          ￥{(price / 100).toFixed(2)}
          <span className="min-price">历史最低：￥{(minPrice / 100).toFixed(2)}</span>
        </div>
      </div>
    </div>
  )
}
